// istanbul ignore file
import { StateShortName, SystemStateName } from './auth';

enum SearchType {
    BETA = 'beta',
    INTERNAL = 'internal',
    EXTERNAL = 'external'
}

 type AddressSearchQuery = {
     addressQuery: string;
     searchType: SearchType;
     agencyId?: number;
     isIncludeMeta?: boolean;
     state?: SystemStateName;
     includeNeighbouringStates?: '0' | '1';
     excludeEnrolledProperties?: '0' | '1';
 };

type SuggestionMaskOptions = {
    maskAgencyId?: number;
    includeMeta?: boolean;
};

type MatchedPropertyService = {
    complianceServiceId: number;
    name: string;
    inspectionStatus: string;
};

type PropertyResolutionSource = 'GNAF_ID' | 'GOLDEN_ADDRESS_ID';
type AddressSource = 'ADDRESSIFY' | 'GOLDEN' | 'MANUAL';

type GoldenSearchMatch = {
    golden_record_id: number;
    address_id: number;
    gnaf_address_id: string;
    score: number;

    complexUnitIdentifier: string;
    complexUnitType: string;
    streetNumber1: string;
    streetNumber2: string;
    streetName: string;
    streetType: string;
    streetPrefix: string;
    streetSuffix: string;
    localityName: string;
    postcode: string;
    stateTerritory: string;

    lat: number;
    lng: number;
};

type DIAddressParts = {
    source: AddressSource;
    gnafId: string | null;
    addressId: number | null;
    unitNumber: string | null;
    unitType: string | null;
    streetNumber1: string;
    streetNumber2: string | null;
    streetName: string;
    streetType: string | null;
    streetPrefix: string | null;
    streetSuffix: string | null;
    suburb: string;
    postcode: string;
    state: StateShortName;
    geoLocation: {
        lat: number | null;
        lng: number | null;
    };
};

type DiAddress = {
    parts: DIAddressParts;
};

type AddressSearchMeta = {
    address: DiAddress;
    confirmedGoldenMatch: GoldenSearchMatch | null;
    goldenMatches: GoldenSearchMatch[];
    propertyResolutionSource: PropertyResolutionSource | null;
};

type AddressMeta = {
    complianceAddressId: number;
    fullAddress: string;
};

type MatchedProperty = {
    compliancePropertyId: number;
    isEnrolled: boolean;
    agency?: {
        complianceAgencyId: number;
        name: string;
    };
    propertyManager?: {
        compliancePropertyManagerId: number;
        name: string;
    } | null;
    services?: MatchedPropertyService[];
};

type AddressSearchResponse = {
    fullAddress: string;
    isNewProperty: boolean;
    isNewAddress: boolean;
    isPotentialDuplicate: boolean;
    goldenAddressId: number | null;
    compliancePropertyId: number | null;
    complianceAddressId: number | null;
    property: MatchedProperty | null;
    creationToken: string | null;

    _meta?: AddressSearchMeta;
};

type AddressCreationParts = {
    unitNumber?: string | null;
    streetNumber: string;
    streetName: string;
    suburb: string;
    state: StateShortName;
    postcode: string;
};

type AddressValidationResponse = {
    isValid: boolean;
    detail: string;
    meta?: Record<string, unknown>;
};

type ManualAddressCreationResponse = {
    fullAddress: string;
    creationToken: string;
};

type AddressCreationResponse = AddressValidationResponse | ManualAddressCreationResponse;

type SuburbSearchResult = {
    complianceSuburbId: number;
    value: string;
};

export {
    SearchType, AddressSearchQuery, SuggestionMaskOptions, AddressSearchResponse,
    AddressCreationParts, AddressValidationResponse, ManualAddressCreationResponse,
    AddressCreationResponse, DIAddressParts,
    MatchedProperty, MatchedPropertyService, AddressMeta,
    SuburbSearchResult,
};
